import axios from "axios"
import { signBySHA256WithRSAWB } from "./jsrsasign"
import { cityOption } from "./mainOption"
import { Message } from "element-ui"

let request = axios.create({
  timeout: 5000,
  baseURL: cityOption.reqBaseUrl
})
// 请求拦截器
request.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/json"
    let deptId = config.headers.deptId ? config.headers.deptId : cityOption.deptId
    config.headers.deptId = deptId
    if (config.url.indexOf("/api/") >= 0) {
      let timeStamp = new Date().getTime()
      let sign = signBySHA256WithRSAWB(deptId, timeStamp)
      config.headers.sign = sign
      config.headers.timeStamp = timeStamp
    }
    return config
  },
)
// 响应拦截器
request.interceptors.response.use(res => {
  if (res.data.code != 200) {
    Message({ message: res.data.msg, type: "error" })
    return
  } else {
    return res
  }
})

export default request